// extracted by mini-css-extract-plugin
module.exports = {"wizardButtons":"BuildingsAndLocationsTemplate_wizardButtons__3Fu-C"};